import axios from "axios";
import React, { useEffect, useState } from "react";
import { awsUrl2 } from "../../config";
import LoadingOverlay from "react-loading-overlay";
import { Modal, Button, Form } from "react-bootstrap";
import carrierList from "../../utils/carrierList.json";

function ConfirmDealButton(props) {
  const {
    rowData,
    isConfirmed,
    updatePopUpData,
    updateConfirmDealMap,
    isWon,
    isLost,
    handleDealConfirm,
    onClickCompanyName,
  } = props;
  let { user_email_id, quoteData, address } = rowData;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [showCarrierModal, setShowCarrierModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [clientId, setClientId] = useState("");
  const [ClinetIDErrorMsg, setClinetIDErrorMsg] = useState(false);
  const [pricingData, setPricingData] = useState(null);

  let existingSelectedCarrier = "";

  // Extract carrier options from carrierList - memoize to prevent recreation on every render
  const carrierOptions = React.useMemo(
    () =>
      Object.entries(carrierList.carrierMapping).map(([key, value]) => ({
        value: key,
        label: value,
      })),
    []
  );

  let handleConfirmClick = async () => {
    if (isWon) {
      // If it's a won deal, immediately show the modal with loading state
      setErrorMsg("");
      setPricingData(null);
      setClinetIDErrorMsg(false);

      setShowCarrierModal(true);
      setIsModalLoading(true); // Use the new loading state for modal content

      try {
        const response = await axios.post(
          awsUrl2 + "/api/getPricingData",
          JSON.stringify({
            userId: user_email_id,
            quoteData,
          })
        );

        const dataFromAPI = response.data;
        setPricingData(dataFromAPI);

        // Check if selectedCarrier exists in the pricing data
        if (!dataFromAPI?.overridesMap?.selectedCarrier) {
          setErrorMsg("No carrier selected for this submission.");
        }
      } catch (error) {
        console.error("Error fetching pricing data:", error);
        setErrorMsg("Failed to fetch pricing data. Please try again.");
      } finally {
        setIsModalLoading(false);
      }
    } else {
      // If it's a lost deal, proceed directly with confirmation
      updatePopUpData({
        show: true,
        title: "Do you wish to confirm this deal?",
        children: (
          <>
            <br></br>
            <span style={{ fontWeight: "bold" }}>
              This action will move the submission to the respective tab.
            </span>
          </>
        ),
        acceptBtn: "Yes",
        acceptBtnCallback: async () => {
          await performConfirmation();
        },
      });
    }
  };

  const handleSaveAndContinue = async () => {
    if (!clientId.trim()) {
      setClinetIDErrorMsg(true);
      return;
    }

    // For won deals, use the carrier from pricing data
    let carrierToUse = pricingData?.overridesMap?.selectedCarrier;

    if (!carrierToUse) {
      setErrorMsg(
        "No carrier selected for this quote. Please contact support."
      );
      return;
    }

    setErrorMsg("");
    setClinetIDErrorMsg("");
    setShowCarrierModal(false);
    await performConfirmation(carrierToUse);
  };

  const performConfirmation = async (carrierKey = null) => {
    setIsLoading(true);
    try {
      // For won deals, we already have the pricing data from handleConfirmClick
      // For non-won deals, we don't have pricing data but don't need it for non-won flow
      let dataFromAPI = isWon ? pricingData : null;

      existingSelectedCarrier =
        carrierKey || dataFromAPI?.overridesMap?.selectedCarrier;

      let userRequestBody = {
        user_email_id,
        deal_confirmed: true,
        existingSelectedCarrier,
      };

      if (clientId) {
        userRequestBody.client_id = clientId;
      }
      let promiseList = [
        axios.post(awsUrl2 + "/api/userTableData/update", userRequestBody),
      ];

      if (quoteData) {
        let { uuid, date } = quoteData;
        let quoteRequestBody = {
          user_email_id,
          timestamp: date,
          peo: "ies",
          address,
          uuid,
          deal_confirmed: true,
        };

        if (clientId) {
          quoteRequestBody.client_id = clientId;
        }

        promiseList.push(
          axios.post(awsUrl2 + "/api/updateUserStatusTable", quoteRequestBody)
        );
      }

      await Promise.all(promiseList)
        .then((res) => {
          setIsLoading(false);
          if (updateConfirmDealMap) {
            updateConfirmDealMap(user_email_id);
          }
          if (handleDealConfirm) {
            let dealFlag = isWon ? true : isLost ? false : "";
            handleDealConfirm(rowData, dealFlag);
          }
        })
        .catch((err) => {
          console.error("Error in confirmation promises:", err);
          setIsLoading(false);
        });
    } catch (e) {
      console.error("Error while updating", e);
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoadingOverlay active={isLoading && !showCarrierModal}>
        <button
          style={{
            fontSize: "12px",
            backgroundColor: "#FFCD4D",
            borderRadius: "4px",
            border: "1px solid #FFCD4D",
          }}
          onClick={handleConfirmClick}
          disabled={
            isConfirmed ||
            (!isWon && !isLost) ||
            (rowData?.pricingStatus !== "Approved" &&
              rowData?.pricingStatus !== "Rejected" &&
              rowData?.pricingStatus !== "Submitted")
          }
        >
          Confirm
        </button>
      </LoadingOverlay>

      {/* Carrier Selection Modal */}
      <Modal
        show={showCarrierModal}
        onHide={() => {
          setShowCarrierModal(false);
          setClinetIDErrorMsg("");
        }}
        centered
      >
        <Modal.Header
          style={{
            borderBottom: "none",
            justifyContent: "center",
            padding: "20px 20px 10px 20px",
          }}
        >
          <Modal.Title style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            Please Enter Client ID{" "}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ paddingTop: "0px", paddingBottom: "20px" }}>
          {errorMsg ? (
            <div
              className="text-danger"
              style={{ fontSize: "0.85rem", marginTop: "5px" }}
            >
              {errorMsg}
            </div>
          ) : isModalLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100px",
                padding: "20px",
              }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "30px", height: "30px" }}
              >
                <span className="sr-only" />
              </div>
            </div>
          ) : (
            <>
              <Form.Group controlId="clientIdInput">
                <Form.Label style={{ fontSize: "1rem", fontWeight: "normal" }}>
                  Client ID
                </Form.Label>
                <Form.Control
                  type="text"
                  className="custom-input"
                  value={clientId}
                  onChange={(e) => {
                    setClientId(e.target.value);
                    if (ClinetIDErrorMsg) setClinetIDErrorMsg(false); // Clear error when user starts typing
                  }}
                  placeholder=""
                  style={{
                    border: "1px solid #d1d5db",
                    borderRadius: "8px",
                    padding: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                />
              </Form.Group>
              {/* Show Client ID error if present */}
              {!clientId && ClinetIDErrorMsg && (
                <Form.Text
                  className="text-danger"
                  style={{ fontSize: "0.85rem" }}
                >
                  Please enter client ID
                </Form.Text>
              )}
              <div className="my-3">
                <p style={{ fontSize: "1rem", fontWeight: "normal" }}>
                  You are going to bind with{" "}
                  <strong>
                    {
                      carrierList.carrierMapping[
                        pricingData?.overridesMap?.selectedCarrier
                      ]
                    }
                  </strong>
                  .
                </p>
                <p style={{ fontSize: "1rem", fontWeight: "normal" }}>
                  Click "View Price" to update the carrier.
                </p>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "none",
            padding: "10px 0 20px 0",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              paddingRight: "20px",
              paddingLeft: "20px",
            }}
          >
            <Button
              variant="secondary"
              onClick={() => {
                setShowCarrierModal(false), setClinetIDErrorMsg("");
              }}
              style={{
                backgroundColor: "white",
                color: "#b34b3e",
                borderColor: "#b34b3e",
                borderRadius: "8px",
                marginRight: "10px",
              }}
            >
              Cancel
            </Button>
            {/* Only show Confirm button if modal is not loading and there are no critical API errors */}
            {!isModalLoading && !errorMsg && (
              <>
                <Button
                  variant="outline-secondary"
                  onClick={() => onClickCompanyName(rowData, "three")}
                  style={{
                    color: "#b34b3e",
                    borderColor: "#b34b3e",
                    borderRadius: "8px",
                    marginRight: "10px",
                  }}
                >
                  View Price
                </Button>
                <Button
                  variant="primary"
                  onClick={handleSaveAndContinue}
                  style={{
                    backgroundColor: "#b34b3e",
                    borderColor: "#b34b3e",
                    borderRadius: "8px",
                  }}
                >
                  Confirm
                </Button>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default React.memo(ConfirmDealButton);
